import React from 'react';
import { Field } from 'formik';
import { TextString } from '../Text';
import withStatus from '../../contexts/withStatus';
import Button from '../Button';

const SubmitButton = ({ name, label, ...props }) => (
  <Field name={name}>
    {({ field, form }) => {
      let disabled, allValues;
      disabled = false;
      allValues = Object.values(form.values).reduce((a, c) => a + c, '');
      if (Object.keys(form.errors).length || !allValues.length) {
        disabled = true;
      }
      return (
        <Button
          className="btn-cleanui btn-blue"
          type="submit"
          variant="contained"
          color="primary"
          disabled={disabled || !form.isValid}
          {...props}
        >
          <TextString content={label || ''} />
        </Button>
      );
    }}
  </Field>
);

export default withStatus(SubmitButton);
